import { render, staticRenderFns } from "./print-visualizacao.vue?vue&type=template&id=8f06fcb0&scoped=true"
import script from "./print-visualizacao.vue?vue&type=script&lang=js"
export * from "./print-visualizacao.vue?vue&type=script&lang=js"
import style0 from "./print-visualizacao.vue?vue&type=style&index=0&id=8f06fcb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f06fcb0",
  null
  
)

export default component.exports